// extracted by mini-css-extract-plugin
export default {"mainBox":"OffsetAnchor-module--mainBox--sRo-6","anchor":"OffsetAnchor-module--anchor--1MT2W"};